// extracted by mini-css-extract-plugin
module.exports = {"container":"ErrorsSummaryBlock-module__container__2IGtQ","icon":"ErrorsSummaryBlock-module__icon__ynYJJ"};